import { lazy } from 'react';

// project imports
import GuestGuard from 'utils/route-guard/GuestGuard';
import MinimalLayout from 'layout/MinimalLayout';
import NavMotion from 'layout/NavMotion';
import Loadable from 'ui-component/Loadable';

// login routing
const AuthLogin = Loadable(lazy(() => import('views/pages/authentication/Azure/Login')));
const Auth = Loadable(lazy(() => import('views/pages/authentication/Auth')));
const Logout = Loadable(lazy(() => import('views/pages/authentication/Logout')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
    path: '/',
    element: <AuthLogin />
    ,
    children: [
        {
            path: '/login',
            element: <AuthLogin />
        },
        {
            path: '/auth',
            element: <Auth />
        },
        {
            path: '/logout',
            element: <Logout />
        }
    ]
};

export default LoginRoutes;
